import { useTranslation } from 'react-i18next'

const REVIEWS_EN = 'https://files.manuscdn.com/user_upload_by_module/session_file/310419663029737303/YogbgYiCQwrdNpzw.png'
const REVIEWS_HE = 'https://files.manuscdn.com/user_upload_by_module/session_file/310419663029737303/TMoZKvAjtIKfKOnt.png'

export default function TestimonialsSection() {
  const { t, i18n } = useTranslation()
  const imgSrc = i18n.language === 'he' ? REVIEWS_HE : REVIEWS_EN

  return (
    <section className="py-16 md:py-20 bg-white dark:bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <p className="text-sm font-semibold uppercase tracking-widest text-green-600 dark:text-green-400 mb-2">
            {t('landing.testimonials.sectionLabel')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
            {t('landing.testimonials.headline')}
          </h2>
        </div>

        <div className="w-full rounded-2xl overflow-hidden shadow-xl">
          <img
            src={imgSrc}
            alt={t('landing.testimonials.headline')}
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  )
}
